var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-captcha"},[_c('span',{staticClass:"mr-3"},[_vm._v("Mã xác thực: ")]),_c('canvas',{ref:"canvas",staticClass:"mr-3",style:({
      width: _vm.displayWidthFormatted
    }),attrs:{"width":_vm.width,"height":_vm.height}}),_c('v-icon',{on:{"click":_vm.reset}},[_vm._v("mdi-reload")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }